import React from 'react';
import Importance from './Importance';
import PlanStudy from './PlanStudy';
import {Link} from 'react-router-dom';

const LessonPlanPage4 = () => {
  return (
    <div>
      <div className="row gx-lg-4 gy-4 mb-4">
        <div className="col-lg-6">
          <div className="font-5 fw-bold mb-4">Послелоги, союзы, частицы</div>
          <div className="row gx-lg-4 gy-4">
            <div className="col-lg-6">
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={4} />
                <PlanStudy levels={[60]} />
                <Link to="/my-lessons/60/grammar">Исключающие аффиксы </Link>
                <br />
                <span className="fst-italic">-сыз/-сіз</span>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={5} />
                <PlanStudy levels={[56]} />
                <Link to="/my-lessons/56/grammar">Себебі, сондықтан </Link>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={3} />
                <PlanStudy levels={[58]} />
                <Link to="/my-lessons/58/grammar">Әйтпесе, есесіне </Link>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={5} />
                <PlanStudy levels={[51]} />
                <Link to="/my-lessons/51/grammar">та/те, да/де (тоже) </Link>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={2} />
                <PlanStudy levels={[52]} />
                <Link to="/my-lessons/52/grammar">қой/ғой </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={5} />
                <PlanStudy levels={[4]} />
                <Link to="/my-lessons/4/grammar">
                  Послелог: <span className="fst-italic">емес</span>
                </Link>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={5} />
                <PlanStudy levels={[57]} />
                <Link to="/my-lessons/57/grammar">Ал, бірақ</Link>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={5} />
                <PlanStudy levels={[50]} />
                <Link to="/my-lessons/50/grammar">Және, немесе, не</Link>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={5} />
                <PlanStudy levels={[11]} />
                <Link to="/my-lessons/11/grammar">Вопросительные частицы</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="font-5 fw-bold mb-4">Дополняющие глаголы</div>
          <div className="row gx-lg-4 gy-4">
            <div className="col-lg-6">
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={4} />
                <PlanStudy levels={[72]} />
                <Link to="/my-lessons/72/grammar">
                  <span className="fst-italic">Тастау, кету, қалу</span>
                </Link>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={2} />
                <PlanStudy levels={[74]} />
                <Link to="/my-lessons/74/grammar">
                  <span className="fst-italic">Беру, салу</span>
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={2} />
                <PlanStudy levels={[73]} />
                <Link to="/my-lessons/73/grammar">
                  <span className="fst-italic">Жіберу, алу</span>
                </Link>
              </div>
              <div className="border bg-white px-2 py-3 mb-3 position-relative">
                <Importance stars={4} />
                <PlanStudy levels={[75]} />
                <Link to="/my-lessons/75/grammar">
                  <span className="fst-italic">Еді, екен</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LessonPlanPage4;
